export default "__VITE_ASSET__C$0GXxeW__"